import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkCasenotesBaseComponent } from './e5core-ui-work-casenotes-base';

@Component({
  selector: 'e5core-ui-work-casenotes-bootstrap',
  templateUrl: './e5core-ui-work-casenotes-bootstrap.component.html',
  styleUrls: ['./e5core-ui-work-casenotes-bootstrap.component.css']
})
export class E5coreUiWorkCasenotesBootstrapComponent extends E5coreUiWorkCasenotesBaseComponent {

}
